export default __webpack_public_path__ + "static/media/919.9081b6b6.png";